import { render } from "./DashboardUsageAnalytics.vue?vue&type=template&id=a4850134"
import script from "./DashboardUsageAnalytics.vue?vue&type=script&lang=js"
export * from "./DashboardUsageAnalytics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__